import Vue from 'vue';

// Shared transition state between the Nóminas and Empleados views: the moment
// the user clicks the navigation button, the CURRENT view already shows the
// loading panel (no layout jump while the new view mounts); the new view's
// first run() releases it via finishNominaViewTransition().
export interface NominaViewTransitionState {
  isTransitioning: boolean;
  targetLabel: string;
}

export const nominaViewTransitionState: NominaViewTransitionState = Vue.observable({
  isTransitioning: false,
  targetLabel: '',
});

export function startNominaViewTransition(targetLabel: string): void {
  nominaViewTransitionState.isTransitioning = true;
  nominaViewTransitionState.targetLabel = targetLabel;
}

export function finishNominaViewTransition(): void {
  nominaViewTransitionState.isTransitioning = false;
  nominaViewTransitionState.targetLabel = '';
}

/**
 * Las pantallas que saben apagar el indicador al montarse.
 *
 * Quien lo enciende al cambiar de empresa no puede saber si el usuario acabará en una de
 * ellas: el guard de la ruta puede desviarlo a `/initial` por permisos, o él mismo puede
 * pulsar otra cosa mientras carga. Sin esta lista, el indicador se quedaría encendido y
 * la próxima visita al módulo empezaría mostrando un «Cargando…» que no espera nada.
 */
export const NOMINA_TRANSITION_ROUTE_NAME_LIST = [
  'nominas',
  'nomina-detail',
  'nominas-papelera',
  'nominas-not-available',
  'empleados',
  'empleado-detail',
];

/** Si al llegar a `routeName` el indicador debe apagarse por no ser del módulo. */
export function shouldCancelNominaTransition(routeName: string): boolean {
  return NOMINA_TRANSITION_ROUTE_NAME_LIST.indexOf(routeName) === -1;
}
